export const FieldLabel = ({ children, color = "text-muted-foreground" }) => (
  <p className={`text-xs font-mono2 uppercase tracking-widest ${color} mb-3`}>{children}</p>
);
